import { FILTER_OPTIONS_DIVIDER } from './constants';
import type {
	DeletedResourceMetadata,
	FilterItem,
	FilterValueType,
} from './types';
import { FilterOptionType } from './types';

const DELETED_ITEM_LABEL_MAP: Partial<Record<FilterOptionType, string>> = {
	[FilterOptionType.COLLECTIONS]: 'Deleted collection',
	[FilterOptionType.OWNERS]: 'Deleted owner',
	[FilterOptionType.TEAMS]: 'Deleted team',
	[FilterOptionType.TAGS]: 'Deleted tag',
	[FilterOptionType.SOURCES]: 'Deleted source',
	[FilterOptionType.INTEGRATION]: 'Deleted integration',
	[FilterOptionType.SCHEMA]: 'Deleted schema',
	[FilterOptionType.DATABASE]: 'Deleted database',
	[FilterOptionType.TABLE]: 'Deleted table',
};

export function getDeletedItemLabel(
	filterOptionType?: FilterOptionType
): string {
	return (
		(filterOptionType && DELETED_ITEM_LABEL_MAP[filterOptionType]) ||
		'Deleted item'
	);
}

export function createDeletedItems(
	selectedValues: FilterValueType[],
	existingItemValues: Set<FilterValueType>,
	filterOptionType?: FilterOptionType
): FilterItem[] {
	return selectedValues
		.filter(
			(selectedValue) =>
				selectedValue !== null && !existingItemValues.has(selectedValue)
		)
		.map((selectedValue) => ({
			label: getDeletedItemLabel(filterOptionType),
			value: selectedValue,
			metadata: {
				isDeleted: true,
				originalValue: selectedValue,
			} as DeletedResourceMetadata,
		}));
}

export function addDeletedItemsToList(
	items: FilterItem[],
	selectedValues: FilterValueType[] | undefined,
	filterOptionType?: FilterOptionType,
	allItems?: (FilterItem | typeof FILTER_OPTIONS_DIVIDER)[]
): FilterItem[] {
	if (!selectedValues?.length) {
		return items;
	}

	// try to check all items, not just the filtered items
	const itemsToCheck = allItems
		? allItems.filter((item) => item !== FILTER_OPTIONS_DIVIDER)
		: items;
	const existingItemValues = new Set(itemsToCheck.map((item) => item.value));
	const deletedItems = createDeletedItems(
		selectedValues,
		existingItemValues,
		filterOptionType
	);

	return deletedItems.length > 0 ? [...deletedItems, ...items] : items;
}
